module.exports = __webpack_public_path__ + "img/home_bg1_mobile.ab73fbcc.jpg";